export default function Checkbox(props) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6032_71876)">
        <rect width="32" height="32" fill="#089408" />
        <path
          d="M13 20.2188L23.5938 9.57812L25 10.9844L13 22.9844L7.42188 17.4062L8.78125 16L13 20.2188Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_6032_71876">
          <path
            d="M0 8C0 3.58172 3.58172 0 8 0H24C28.4183 0 32 3.58172 32 8V24C32 28.4183 28.4183 32 24 32H8C3.58172 32 0 28.4183 0 24V8Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
